import { IProject } from "../models";

export function ProjectsNameMuntipleCard(item, array: boolean) {
  function getProjects() {
    return item?.projects
      ?.map((itemProject: IProject) => {
        return itemProject?.name;
      })
      ?.join(", ");
  }
  return (
    <div className="between flex row gap20">
      <span>Projetos: </span>
      <span className="text-end limit-10-char">{array ? getProjects() : item?.projects?.name}</span>
    </div>
  );
}

export function ProjectHoursBalance(item, multipleCard: boolean = false) {
  return (
    <div className="flex row between">
      <span>Saldo: </span>
      <span>{multipleCard ? item?.projects?.balance : item?.totalProjects}</span>
    </div>
  );
}
